import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import GuestUserNavbar from 'src/components/GuestUserAssessment/GuestUserNavbar';
import { InterviewedByType, InterviewedOnType } from 'src/components/scorecard/DetailCard';
import ScorecardContainer from 'src/components/scorecard/ScorecardContainer';
import Container from 'src/components/shared/Container';
import { useUserContext } from 'src/context/UserProvider';
import { useGuestUserValidateJwt } from 'src/hooks/hiringAssessment.hooks';
import { useGetMeetingScoreCard } from 'src/hooks/meeting.hooks';
import { Loader } from 'ui';

const ScorecardPage = () => {
	const { id } = useParams();
	const { isGuestUser, setIsGuestUser } = useUserContext();
	const guestUserJwtToken = localStorage.getItem('guestUserJwtToken') || '';

	const {
		data: meetingScoreCardData,
		isLoading: isMeetingScoreCardDataLoading,
		isError: isMeetingScoreCardDataError,
	} = useGetMeetingScoreCard(id ?? '');

	const { data: guestUserValidateJwtData, error: guestUserValidateJwtError } =
		useGuestUserValidateJwt(guestUserJwtToken);

	useEffect(() => {
		if (guestUserValidateJwtData) {
			setIsGuestUser(true);
		} else {
			setIsGuestUser(false);
		}
	}, [guestUserValidateJwtData, setIsGuestUser]);

	if (isMeetingScoreCardDataLoading) {
		return <Loader />;
	}

	if (isMeetingScoreCardDataError || !meetingScoreCardData?.skillScores) {
		return (
			<Container>
				<div className="p-4 text-center">
					Our apologies, but it seems there is an issue with generating your Technical Scorecard. Please contact
					support@levelup.inc for assistance.
				</div>
			</Container>
		);
	}

	const interviewedByData: InterviewedByType = {
		interviewerName: meetingScoreCardData?.hostDetails?.name ?? '',
		companyName: meetingScoreCardData?.hostDetails?.currentCompany ?? '',
		companyRole: meetingScoreCardData?.hostDetails?.currentRole ?? '',
		linkedinLink: meetingScoreCardData?.hostDetails?.linkedUrl ?? '',
		imgUrl: meetingScoreCardData?.hostDetails?.imageURL ?? '',
	};

	const interviewedOnData: InterviewedOnType = {
		startTime: String(meetingScoreCardData?.meetingStartTime) ?? '',
		duration: meetingScoreCardData?.duration ?? 0,
	};

	return (
		<>
			{isGuestUser && <GuestUserNavbar />}
			<div className={isGuestUser ? 'mt-16' : ''}>
				<ScorecardContainer
					scorecardTitle={meetingScoreCardData?.title ?? ''}
					interviewedBy={interviewedByData}
					interviewedOn={interviewedOnData}
					data={{
						meetingScore: meetingScoreCardData?.meetingScore ?? 0,
						skillScores: meetingScoreCardData?.allMeetingSkillScores ?? [],
						status: meetingScoreCardData?.meetingStatus,
						meetingId: id ?? '',
					}}
				/>
			</div>
		</>
	);
};

export default ScorecardPage;
